import { z } from 'zod';
import { uuidSchema } from '../../common/schemas/id.schemas.js';
/** `YYYY-MM-DD`, the reporting Sunday. */
export const isoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Use YYYY-MM-DD');
export const weekSchema = z.object({
    id: uuidSchema,
    year: z.number().int(),
    weekNumber: z.number().int().min(1).max(53),
    /** The reporting Sunday; the week covers the seven days ending the Saturday before. */
    weekDate: isoDateSchema,
    label: z.string(),
});
export const listWeeksInputSchema = z.object({
    year: z.coerce.number().int().min(2000).max(2100).optional(),
});
export const listWeeksOutputSchema = z.object({
    items: z.array(weekSchema),
    /** The week of the Sunday on or before today in Asia/Amman; `null` when that week was never generated. */
    currentWeekId: uuidSchema.nullable(),
});
export const addWeekInputSchema = z.object({});
//# sourceMappingURL=weeks.schemas.js.map